module.exports = __webpack_public_path__ + "static/ebr-1-a38646fe1d1f03a16ac33cd281e079e9.jpg";